import { SxProps } from '@mui/material'

interface CheckboxIconStyles {
  checkboxIcon: SxProps
  checkedIconWrapper: SxProps
  checkedIcon: SxProps
}

export const checkboxIconStyles: CheckboxIconStyles = {
  checkboxIcon: {
    borderRadius: 0.75,
    width: 16,
    height: 16,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.primary',
    '.Mui-focusVisible &': {
      outline: '2px auto',
      outlineColor: 'border.primary',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      borderColor: 'brand.primary600',
    },
    'input:disabled ~ &': {
      backgroundColor: 'utils.gray50',
      borderColor: 'border.primary',
    },
  },
  checkedIconWrapper: {
    backgroundColor: 'brand.primary600',
    borderColor: 'brand.primary600',
    position: 'relative',
    'input:disabled ~ &': {
      borderColor: 'border.primary',
    },
  },
  checkedIcon: {
    color: 'background.default',
    position: 'absolute',
    top: 0,
    left: 0,
    'input:disabled ~ div &': {
      color: 'border.primary',
    },
  },
}
